import { Injectable } from '@angular/core';
import { CanComponentDeactivate } from '../directives/component.deactivate.directive';

@Injectable(
  { providedIn: 'root' }
)

export class CanDeactivateGuard {
    canDeactivate(component: CanComponentDeactivate): boolean {
      if(!component.canDeactivate()){
        if (confirm('You have unsaved changes, do you want to leave the page?')) {
            return true;
        } else {
            return false;
        }
      }
      return true;
    }
}
